import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

/**
 * De tekenaar voor het Krabbelgotchi-beestje, alleen voor de mod.
 *
 * Links de zeventien stukjes met een bolletje dat zegt of er al iets getekend is,
 * rechts het doekje van 16 bij 16 met het palet eronder. Je komt hier uit het
 * modgereedschap en het kruisje brengt je daar weer terug: dit is een lade van dat
 * venster en geen losstaand scherm.
 *
 * Zie logic/beestje.js voor wat de knoppen doen en STUKKEN in lib/tamagotchi.js
 * voor de lijst.
 */
export default function Beestje({ v }) {
  if (!v.showBeestje) return null;
  return (
    <div className="gp-laag" style={{ position: 'fixed', inset: '0', background: 'rgba(36,27,58,.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 97, padding: '20px' }} onClick={v.sluitBeestje}>
      {/* De maat komt uit de vals: het kiesscherm is zo breed als zijn tegels, de
          tekenaar houdt de ruimte die de banden nodig hebben. Zie beestjeVensterStyle
          in logic/beestje.js. */}
      <div className="gp-venster gp-vast" style={css(v.beestjeVensterStyle)} onClick={v.stopProp}>

        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flex: '0 0 auto' }}>
          {!v.showBeestjeSlots ? (
            <button onClick={v.naarSlots} className="gp-btn" style={{ flex: '0 0 auto', height: '34px', borderRadius: '12px', fontSize: '13px', padding: '0 12px' }}>
              <Interp v={v.beestjeTerugLabel} />
            </button>
          ) : null}
          <div style={{ fontSize: '19px', fontWeight: 700, lineHeight: 1.2, flex: '1 1 auto', minWidth: '0' }}>
            <Interp v={v.beestjeTitel} />
          </div>
          <button onClick={v.sluitBeestje} title="Sluiten" style={css(v.sluitStyle)}>
            <Kruis maat={22} />
          </button>
        </div>

        {v.showBeestjeMist ? (
          <div style={css(v.beestjeMistStyle)}><Interp v={v.beestjeMistTekst} /></div>
        ) : null}

        {/* Vijf beestjes en de spullenbak. Bij een nieuw ei valt er willekeurig een
            van de vijf; kiezen kun je hem niet. De objecten zijn van iedereen. */}
        {v.showBeestjeSlots ? (
          <div style={css(v.beestjeSlotRasterStyle)}>
            {toList(v.beestjeSlots).map((b, $index) => (
              <React.Fragment key={$index}>
                <button onClick={b?.onClick} className="gp-btn gp-plat" style={css(b?.tegelStyle)}>
                  <span style={css(v.beestjeSlotDoekStyle)}>
                    {toList(b?.pixels).map((p, $i) => (
                      <span key={$i} style={{ position: 'absolute', left: (p.x * b.vak) + 'px', top: (p.y * b.vak) + 'px', width: b.vak + 'px', height: b.vak + 'px', background: v.paletHex?.[p.k] }} />
                    ))}
                  </span>
                  <span style={css(b?.naamStyle)}><Interp v={b?.naam} /></span>
                  <span style={css(b?.hoeveelStyle)}><Interp v={b?.hoeveel} /></span>
                </button>
              </React.Fragment>
            ))}
          </div>
        ) : (
        <div style={css(v.beestjeWerkStyle)}>

          <div
            onPointerUp={v.stukUp} onPointerLeave={v.stukUp} onPointerCancel={v.stukUp}
            style={css(v.beestjeDoekVelStyle)}
          >
            <div style={css(v.beestjeDoekRijStyle)}>
              {toList(v.beestjeBanden).map((band, $k) => (
                <React.Fragment key={$k}>
                  <div>
                    <div style={css(band?.rijStyle)}>
                    {toList(band?.tegels).map((d, $index) => (
                      <div key={$index} style={css(d?.tegelStyle)}>
                        <div onPointerDown={d?.onClick} style={css(d?.doekStyle)}>
                          {toList(d?.vakken).map((c, $i) => (
                            <div key={$i} onPointerDown={c?.onDown} onPointerEnter={c?.onOver} style={css(c?.style)} />
                          ))}
                          {/* Het gezichtje op zijn plek. Doorschijnend en klikdoorlatend:
                              op dit doekje teken je het lijf. */}
                          {d?.toonSel ? <span style={css(d?.selStyle)} /> : null}
                          {toList(d?.schim).map((p, $s) => (
                            <span key={'s' + $s} style={{ position: 'absolute', left: (p.x * d.schimVak) + 'px', top: (p.y * d.schimVak) + 'px', width: d.schimVak + 'px', height: d.schimVak + 'px', background: v.paletHex?.[p.k], opacity: 0.4, pointerEvents: 'none' }} />
                          ))}
                        </div>
                        <div style={css(d?.kapStyle)} title={d?.titel}>
                          <div style={css(d?.titelStyle)}><Interp v={d?.naam} /></div>
                        </div>
                      </div>
                    ))}
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Eén regel: kleuren, gum, een stap terug en vooruit, en de twee
              knoppen die over het aangewezen stukje gaan. */}
          <div style={css(v.beestjePaletStyle)}>
            {toList(v.beestjeKleuren).map((k, $index) => (
              <React.Fragment key={$index}>
                <button onClick={k?.onClick} className="gp-swatch" title={k?.titel} aria-label={k?.titel} style={css(k?.style)} />
              </React.Fragment>
            ))}
            {/* De kleuren links, het gereedschap rechts van het streepje. */}
            <span style={css(v.beestjeScheiStyle)} />

            {/* Potlood, gum en emmer: letterlijk de tekentjes van het tekendoek, op
                dezelfde maat en dikte. Hetzelfde gereedschap hoort niet twee
                gezichten te hebben. Zie sectie 8 van CLAUDE.md. */}
            <button onClick={v.pakStukPotlood} className="gp-btn" title="Potlood" aria-label="Potlood" aria-pressed={v.beestjePotlood ? 'true' : 'false'} style={css(v.beestjePotloodStyle)}>
              <svg width={v.beestjeIcoon} height={v.beestjeIcoon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.beestjeIcoonLijn} strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
              </svg>
            </button>

            <button onClick={v.pakStukGum} className="gp-btn" title="Gum" aria-label="Gum" aria-pressed={v.beestjeGum ? 'true' : 'false'} style={css(v.beestjeGumStyle)}>
              <svg width={v.beestjeIcoon} height={v.beestjeIcoon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.beestjeIcoonLijn} strokeLinecap="round" strokeLinejoin="round">
                <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
                <path d="M22 21H7" />
              </svg>
            </button>

            <button onClick={v.pakStukEmmer} className="gp-btn" title={v.beestjeEmmerTitel} aria-label={v.beestjeEmmerTitel} aria-pressed={v.beestjeVul ? 'true' : 'false'} style={css(v.beestjeEmmerStyle)}>
              <svg width={v.beestjeIcoon} height={v.beestjeIcoon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.beestjeIcoonLijn} strokeLinecap="round" strokeLinejoin="round">
                <path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z" />
                <path d="M2 13h15" />
                <path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z" />
              </svg>
            </button>

            <button onClick={v.pakStukSchaar} className="gp-btn" title="Vlak aanwijzen en verslepen" aria-label="Selectie" aria-pressed={v.beestjeKies ? 'true' : 'false'} style={css(v.beestjeSchaarStyle)}>
              <svg width={v.beestjeIcoon} height={v.beestjeIcoon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={v.beestjeIcoonLijn} strokeLinecap="round" strokeLinejoin="round" strokeDasharray="3.4 2.8">
                <rect x="3.8" y="3.8" width="16.4" height="16.4" rx="1.2" />
              </svg>
            </button>

            <button onClick={v.stapTerug} disabled={v.beestjeTerugUit} className="gp-btn" title="Stap terug (Cmd+Z)" aria-label="Stap terug" style={css(v.beestjeStapStyle)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 14 4 9l5-5" />
                <path d="M4 9h9a7 7 0 0 1 0 14H8" />
              </svg>
            </button>
            <button onClick={v.stapVooruit} disabled={v.beestjeVooruitUit} className="gp-btn" title="Stap vooruit (Cmd+Shift+Z)" aria-label="Stap vooruit" style={css(v.beestjeStapStyle)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.3" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 14 5-5-5-5" />
                <path d="M20 9h-9a7 7 0 0 0 0 14h5" />
              </svg>
            </button>

          </div>

          {/* De twee brede knoppen op hun eigen regel, even hoog als de bewaarknop. */}
          <div style={css(v.beestjePaletStyle)}>
            <button onClick={v.neemHuidigeOver} disabled={v.beestjeKnopUit} className="gp-btn" title={v.beestjeStukNaam} style={css(v.beestjeKnopStyle)}>
              Standaard
            </button>
            <button onClick={v.wisStuk} disabled={v.beestjeKnopUit} className="gp-btn" title={v.beestjeStukNaam} style={css(v.beestjeKnopStyle)}>
              Leegmaken
            </button>
          </div>

          {v.showBeestjeFout ? (
            <div style={css(v.beestjeFoutStyle)}><Interp v={v.beestjeFout} /></div>
          ) : null}

          <button onClick={v.bewaarStuk} disabled={v.beestjeBewaarUit} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
            <Interp v={v.beestjeBewaarLabel} />
          </button>

        </div>
        )}
      </div>
    </div>
  );
}
